import type { ReactNode } from 'react';
import { Header } from './_shared';

export type TitleSlideProps = {
  eyebrow: ReactNode;
  title: ReactNode;
  sub?: ReactNode;
  /** Brand text rendered next to the mark image at the bottom. Default: "StreamNative". */
  markText?: string;
  /** Brand mark image (defaults to the repo's SN logomark). */
  markSrc?: string;
};

export function TitleSlide({
  eyebrow,
  title,
  sub,
  markText = 'StreamNative',
  markSrc = '/assets/logomark-blue.svg',
}: TitleSlideProps) {
  return (
    <div className="slide-body">
      <Header eyebrow={eyebrow} titleSize="h1" title={title} sub={sub} />
      <div className="sn-work sn-work--end">
        <div className="sn-mark">
          <img src={markSrc} alt={markText} />
          <span className="sn-mark-text">{markText}</span>
        </div>
      </div>
    </div>
  );
}
